<style>
.th-col {
  font-weight: bold;
  background-color: #f2f3f4;
  font-size: 13px;
  padding-top: 6px;
  padding-bottom: 6px;
  border: 1px solid #d6d4d4;
}
.td-item {
  font-size: 13px;
  background-color: gainsboro;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Infomación de Comisiones</b-card-header>
      <b-card-body>
        <div v-if="model.commissions.length > 0" class="col-9" style="margin: auto;">
          <div class="row">
            <div class="col-3 text-center th-col">Medio de Pago</div>
            <div class="col-2 text-center th-col">Cuotas</div>
            <div class="col-2 text-center th-col">Comisión</div>
            <div class="col-3 text-center th-col">Plazo de Acreditación</div>
          </div>
          <div
            class="row"
            v-for="(itemCommission, index) in this.model.commissions"
            v-bind:key="index"
          >
            <div class="col-3 text-center td-item">{{itemCommission.PaymentMethodName}}</div>
            <div class="col-2 text-center td-item">{{itemCommission.Dues}}</div>
            <div class="col-2 text-center td-item">{{itemCommission.CommissionPercentage}}</div>
            <div class="col-3 text-center td-item">{{itemCommission.Days}}</div>
          </div>
        </div>

        <div
          class="col-10 text-center"
          style="margin-top: 30px;font-weight: bold;font-size: 13px"
        >Costo por Adelanto</div>
        <div
          class="col-10 text-center"
          style="font-size: 13px"
        >Se cobrará el {{model.commissionPercentagePerDay}}% por dia de adelanto</div>
        <div
          class="col-10 text-center"
          style="font-size: 13px"
        >Los valores representan las comisiones sin IVA incluido</div>
        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  name: "InformacionComisionesFintouch",
  data() {
    return {
      model: {
        commissions: [],
        commissionPercentagePerDay: 0
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push("SmartPost");
    },
    getInformacionComisiones() {
      let context = this;

      axiosHelpers.axiosGet(
        "OperationsFintouch/GetInfoCommissions",
        {},
        this,
        function(response) {
          context.model.commissionPercentagePerDay = response.ResponseVM.CommissionPercentagePerDay;
          context.model.commissions = [];
          var PaymentMethodName = "";
          var lastPaymentMethodName = "";
          response.ResponseVM.Items.forEach(x => {
            if (lastPaymentMethodName != x.PaymentMethodName) {
              PaymentMethodName = x.PaymentMethodName;
            } else {
              PaymentMethodName = "";
            }
            var commission = {
              PaymentMethodName: PaymentMethodName,
              Dues: x.Dues,
              CommissionPercentage: x.CommissionPercentage,
              Days: x.Days
            };
            lastPaymentMethodName = x.PaymentMethodName;
            context.model.commissions.push(commission);
          });
        }
      );
    }
  },
  mounted() {
    this.getInformacionComisiones();
  }
};
</script>